DplLink.appClass = 'atmlink';

// Default cloundfront location for images loded in JS. updated by grunt.
DplLink.cloudfront = 'https://d314gwuafhjlgl.cloudfront.net/';

// Rest host will be empty for deployment but active for local development.  updated by grunt
if(import.meta.env.VITE_DEBUG==='TRUE'){
	DplLink.resthost = 'http://localhost:3000'; // Used when testing rest services locally
}
//DplLink.resthost = 'https://herculesbeta.dplwireless.com';  // Used when only testing web locally


DplLink.loginUrl = "/login.html";

DplLink.NotifyMessageTypes = {
    VALIDATE_EMAIL: 1,
    RESET_PASSWORD: 2,
    CHANGE_USERNAME_TO_EMAIL: 3
};

DplLink.apiUrls = {
    logout: '/r/p/logout',
    options: '/r/p/options2',
    assetData: '/r/p/assetliststate45',
    assetDataMinim: '/r/p/assetliststate45minim',
    alarmUrl: '/r/p/groupactivealarms2',
    filterlayout: '/r/p/filterlayout9',
    fleetDashboardLayout: '/r/p/fleetdashboardlayout17',
    fleetDashboardState: '/r/fleetdashboardstate',
    fleetTransactionLog: '/r/p/fleettransactionlog4',
    fleetdailywithdrawals: '/r/p/dailywithdrawals5',
    fleetmonthlywithdrawals: '/r/p/monthlywithdrawals',
    fleetdatause:'/r/p/fleetdatause5',
    fleetSmartRebootStats: '/r/p/fleetsmartrebootstats2',
    fleetUptime: '/r/fleet/health/uptime',
    transactionErrorStats: '/r/p/transactionerrorstats',
    allcashlevels: '/r/p/allcashlevels5',
    deviceTransactionLog: '/r/p/devicetransactionlog',
    //alarmsLayout: '/r/p/alarmslayout',
    alarmsState: '/r/fleetdashboardstate',
    dashboardLayout: '/r/p/dashboardlayout51',
    dashboardState: '/r/dashboardstate64',
    assetLayout: '/r/p/assetlayout10',
    assetState: '/r/p/assetstate12',
    securityLayout: '/r/p/securitylayout3',
    securityState: '/r/p/securitystate14',
    securityTrackHistory: '/r/p/securitytrackhistory',
    securityIncidents: '/r/p/securityincidents',
    locationSequence: '/r/p/locationsequence',
    settingsLayout: '/r/p/settinglayout56',
    settingsState: '/r/p/settingstate33',
    settingsLocation: '/r/p/settingslocation2',
    restartToggle: '/r/p/togglerestart',
    toggleexternallink: '/r/p/toggleexternallink', 
    actionsLayout: '/r/p/actionlayout7',
    actionsState: '/r/p/actionstate8',
    diagnosticLayout: '/r/diagnosticlayout',
    diagnosticState: '/r/diagnosticparamstate',
    warningState: '/r/warningparamstate',
    tamperState: '/r/tamperparamstate',
    monitoringState: '/r/monitoringparamstate',
    rssiState: '/r/p/rssistate',
    extraColumns: '/r/p/extracolumns',
    favDatatags: '/r/p/favdatatags2',
    datatags: '/r/p/datatags3',
    datatagNames: '/r/p/datatagnames',
    alarmActivity: '/r/p/alarmactivityinfo3',
    locationActivity: '/r/p/locationactivityinfo2',
    valueActivity: '/r/p/valueactivityinfo2',
    customReportParams: '/r/p/customreportparams',
    customReportRParams: '/r/p/customreportrparams',
    customReportGenParams: '/r/p/customreportgenparams2',
    customReports: '/r/p/customreports',
    shortcuts: '/r/p/shortcuts',
    cloneDefaultCompany: '/r/p/clonedefaultcompany',
    workNotes: '/r/p/worknotes3',
    workTypes: '/r/p/worktypes',
    machineTypes: '/r/p/assettypes',
    alarmDescription: '/r/p/alarmdescription',
    valueDescription: '/r/p/valuedescription',
    clearAlarmGroup: '/r/p/clearalarmgroup',
    transformFunction: '/r/p/transformfunction',
    transformValue: '/r/p/transformvalue',
    rTransformValue: '/r/p/rtransformvalue',
    serialInUse: '/r/p/serialinuse',
    nextScheduleTime: '/r/p/nextscheduletime',
    //displayClass put urls
    resetServiceMeterPut: '/r/p/resetservicemeter2',
    assetTypePut: '/r/p/assettype',
    workNotePut: '/r/p/worknote2',
    noteTypePut: '/r/p/notetype',
    toolPut: '/r/p/executetool3',
    textualPut: '/r/p/settingstate6',
    settingPut: '/r/p/settingstate10',
    actionPut: '/r/p/asset3',
    cancelTRPut: '/r/p/canceltaskrequest',
    assetPut: '/r/p/asset/',
    machineColorPut: '/r/p/machinecolor',
    alarmlogPut: '/r/p/',
    userOptions: '/r/p/useroptions9',
    userInfo: '/r/userinfo',
    roles: '/r/roles',
    switchUserAccount: '/r/user/switchaccount',
    gadminUserOptions: '/r/p/gadminuseroptions',
    companyOptions: '/r/p/companyoptions13',
    clone: '/r/clone',
    resetToGenuineSelf: '/r/clone/reset',
    authFetchToken: '/r/auth/fetch-token',
    userPrefs: '/r/p/userpref',
    userPortalViews: '/r/p/userportalviews',
    datatagInfo: '/r/p/datataginfo',
    serialnumHistory: '/r/p/serialnumhistory',
    allUsers: '/r/p/allusers18',
    allSchedules: '/r/p/allschedules5',
    schedulePut: '/r/p/notificationschedule5',
    allGroups: '/r/p/allgroups',
    groupUsers: '/r/p/groupusers',
    groupMachines: '/r/p/groupmachines',
    groupOptions: '/r/p/groupoptions',
    groupPut: '/r/p/group2',
    operatorHistory: '/r/p/operatorhistory',
    operatorPut: '/r/p/assignoperator',
    createUser: '/r/user/create',
    //displayClass post urls
    shortCutPost: '/r/p/shortcut',
    feedbackPut: '/r/p/feedback',
    createApiUser: '/r/createApiUser/',
    deleteNoteType: '/r/p/deletenotetype',
    deleteAssetType: '/r/p/deleteassettype',
    emailErrorPut: '/r/p/emailerror',
    tempPassword: '/r/p/temppassword',
    reportSchedulePut: '/r/p/reportschedule',
    migrateSerialNum: '/r/p/migrateserialnum2',
    resetschedulestartdate: '/r/p/resetschedulestartdate',
    redolastscheduleperiod: '/r/p/redolastscheduleperiod',
    templates: '/r/p/templates',
    applyTemplatePut: '/r/p/applytemplate',
    ieupdown: '/r/ieupdown',
    tprovhealth: '/r/p/tprovhealthstate',
    emailValidation: '/r/emailvalidation',
    pwResetTokenValidation: '/r/pwresettokenvalidation',
    resetPassword: '/r/resetpassword',
    changePassword: '/r/changepassword',
    changeuseremail: '/r/p/changeuseremail',
    requestemailvalidation: '/r/requestemailvalidation',
    mfaVerify: '/r/mfa-verify',
    mfaVerifyLogin: '/r/mfa-verify-login',
    mfaVerifyCheck: '/r/mfa-verify-check',
    mfaRemove: '/r/mfa-remove',
    requestpasswordreset: '/r/requestpasswordreset',
    userlog: '/r/userlog',
    acceptTermsOfService: '/r/acceptterms/',
    seenNewsPut: '/r/p/seennews',
    alarms: '/r/p/alarm2',
    userPut: '/r/user/edit',
    assignUserRole: '/r/user/assign-role',
    deviceInfo: '/c/deviceinfo',
    desiredSimStatus: '/r/p/desiredsimstatus2',
    ecoreActiveatePut: '/r/ecoreactivate',
    protectorArmPut: '/r/p/protectorarmed3',
    protectorLinkPut: '/r/p/authtokenlink',
    testAlert: '/r/p/testalert',
    transactionInfo: '/r/p/transactionInfo',
    notesLayout: '/r/p/noteslayout',
    notesState: '/r/p/notesstate',
    rmsLayout: '/r/p/rmslayout4',
    rmsState: '/r/p/rmsstate14',
    rmsJournal: '/r/rmsjournal',
    rmsParams: '/r/rmsparams',
    //rmsSetup: '/r/rmssetup',
    rmsConfig: '/r/p/rmsconfig4',
    rmsAuthorizeValidation: '/r/p/rmsauthorizevalidation',
    rmsSchedule: '/r/p/rmsschedule',
    predictCashRunout:'/r/predictedcash13',
    allTimeMachineStats:'/r/machinealltimestats',
    companiesForCloning:'/r/p/companiesforcloning2',
    usersForCloning:'/r/p/usersforcloning5',
    userForGadmin:'/r/p/userforgadmin',
    journalEmails:'/r/journalemail',
    enablesuperuser:'/r/p/enablesuperuser',
    ecoreUnsuspendPut: '/r/ecoreunsuspend',
	companySettings: '/r/p/companysettings14',
	devicelistforblkfn: '/r/p/devicelistforblkfn',
	devicelistforfind: '/r/p/devicelistforfind',
	softwareUpdateReport: '/r/p/softwareupdatereport',
	softwareUpdateStats: '/r/p/softwareupdatestats',
	herculesAiCoverageReport: '/r/p/herculesaicoveragereport',
	moveserialstocompany:'/r/p/moveserialstocompany',
    movemachinestocompany:'/r/p/movemachinestocompany',
    resetmachinedata:'/r/p/resetmachinedata',
    addTerminal:'/r/device',
    lastrx:'/r/lastrxstate',
    actionsList: '/r/p/actionslist',
    actionCancel:'/r/p/cancelworkaction',
    actionScheduleCancel:'/r/p/stopworkschedule',
    workactiondone:'/r/p/workactiondone',
    changeLowCashLevel:'/r/p/changelowcashlevel', 
    eventlog:'/r/p/eventlog20',
    assetlistMaintenance:'/r/p/assetlistmaintenance',
    assetlistCustomViewData:'/r/p/assetlistcustomviewdata2',
    actionScheduleEdit:'/r/p/editworkschedule',
    //incidents:'/r/p/incidents6',
    incidents:'/r/p/incidentsgrouped13',
    incidentalarms:'/r/p/incidentalarms',
    //incidentnotifs:'/r/p/incidentnotifs',
    //incidentstatePut:'/r/incidentstate2',
    //incidentdonestatusPut:'/r/incidentdonestatus2',
    incidentassignedtoPut:'/r/incidentassignedto2',
    incidentcounts:'/r/p/incidentcounts2',
    scheduledworkPut:'/r/p/scheduledwork7',
    validatePhoneNumber:'/r/validatephonenumber',
    machinegroups: '/r/p/machinegroups',
	incidentevents:'/r/p/incidenteventsgrouped9',
	incidentcommand:'/r/incidentcommand',
    hercaisettingsput:'/r/p/hercaisettings3',
    publicip:'/r/getpublicip',
    signalhistory:'/r/p/signalhistory8',
    datausagehistorydaily:'/r/p/datausagehistorydaily',
    datausagehistorymonthly:'/r/p/datausagehistorymonthly',
    versioncheck:'/r/p/versioncheck',
    portalBanner: '/r/p/portalbanner',
    gadminAccounts: '/r/p/gadminaccounts',
    helpContent:'/r/helpcontent',
    apiKey: '/r/apikey',
    apiKeyUnmasked: '/r/apikey/unmasked',
    apiKeyGenerate: '/r/apikey/generate',
    apiKeyRotate: '/r/apikey/rotate ',
    userCompanies: '/r/user/company',
    accountlinkinvite: '/r/accountlinkinvite',
    accountlinkconfirm: '/r/accountlinkconfirm',
    companyinvite: '/r/companyinvite',
    companyconfirm: '/r/companyinviteconfirm',
    companyinviteresend: '/r/companyinvite/resend',
    networkConfigurations: '/r/p/networkconfigurations',
    billing: '/r/p/billingdata',
    networkTabLayout: '/r/p/networktablayout4',
    networkTabState: '/r/p/networktabstate2',
    tamperConfigState: '/r/p/tamperconfigstate',
    tamperConfigTemplateState: '/r/p/tamperconfigtemplatestate',
    paiopsConfigState: '/r/p/paiopsconfigstate',
    paiopsStatus: '/r/p/paiopsstatus',
    monitorUsage: '/r/p/monitorusage',
    monitorCheckHistory: '/r/p/monitorcheckhistory',
    monitorBaselineState: '/r/p/monitorbaselinestate',
    monitorBaselineConfig: '/r/p/monitorbaselineconfig',
    monitorBaselineRecompute: '/r/p/monitorbaselinerecompute',
    // DIRECT network JSON monitor section (attempttime/badqualtime + remotes).
    deviceNetworkMonitorConfig: '/r/p/devicenetworkmonitorconfig',
    paiopsOptConnectRouter: '/r/paiops/optconnect/router-stats',
    paiopsDemoDevices: '/r/paiops/demo/devices',
    paiopsDemoStatus: '/r/paiops/demo/status',
    paiopsDemoRun: '/r/paiops/demo/run',
    healthReportData: '/r/health/uptime',
    deviceInstall: '/r/device/install',
    deviceFirmware: '/r/device/firmware',
    deviceFirmwareUpdate: '/r/device/firmware/update',
    device: '/r/device',
};

//mobile only urls
//DplLink.apiUrls.assetList = '/r/p/assetlist8';


switch (DplLink.appClass) {
    case 'amslink':
        DplLink.validationHost = 'https://amslink.dplwireless.com';
        if(import.meta.env.VITE_DEBUG==='TRUE'){
        	DplLink.validationHost = 'https://amslinkbeta.dplwireless.com';
		}
        break;
    case 'atmlink':
        DplLink.validationHost = 'https://hercules.dplwireless.com';
        if(import.meta.env.VITE_DEBUG==='TRUE'){
        	DplLink.validationHost = 'https://herculesbeta.dplwireless.com';
		}
        break;
    case 'boatlink':
        DplLink.validationHost = 'https://boatlink.dplwireless.com';
        if(import.meta.env.VITE_DEBUG==='TRUE'){
        	DplLink.validationHost = 'https://boatlinkbeta.dplwireless.com';
		}
        break;
}

//DplLink.validationHost = 'http://localhost:8081';

DplLink.getUserPortalPrefs = function(done) {
    DplLink.getUserPrefs('userPortalPrefs',(prefs,err)=>{
         if(prefs){
             DplLink.userPortalPrefs = prefs;

            if(DplLink.userPortalPrefs.forecast == undefined){
                DplLink.userPortalPrefs.forecast = DplLink.defaultUserPortalPrefs.forecast;
            }
            if(DplLink.userPortalPrefs.ims_smartfilter == undefined){
                DplLink.userPortalPrefs.ims_smartfilter = DplLink.defaultUserPortalPrefs.ims_smartfilter;
            }
            if(DplLink.userPortalPrefs.ims_filter1 == undefined){
                DplLink.userPortalPrefs.ims_filter1 = DplLink.defaultUserPortalPrefs.ims_filter1;
            }
            if(DplLink.userPortalPrefs.ims_filter2 == undefined){
                DplLink.userPortalPrefs.ims_filter2 = DplLink.defaultUserPortalPrefs.ims_filter2;
            }
            if(DplLink.userPortalPrefs.ims_filter_type == undefined){
                DplLink.userPortalPrefs.ims_filter_type = DplLink.defaultUserPortalPrefs.ims_filter_type;
            }
            if(DplLink.userPortalPrefs.ims_filter_incident == undefined){
                DplLink.userPortalPrefs.ims_filter_incident = DplLink.defaultUserPortalPrefs.ims_filter_incident;
            }
            if(DplLink.userPortalPrefs.ims_rowcount== undefined){
                DplLink.userPortalPrefs.ims_rowcount = DplLink.defaultUserPortalPrefs.ims_rowcount;
            }
            if(DplLink.userPortalPrefs.fleet_transactions_filter1 == undefined){
                DplLink.userPortalPrefs.fleet_transactions_filter1 = DplLink.defaultUserPortalPrefs.fleet_transactions_filter1;
            }
            if(DplLink.userPortalPrefs.theme == undefined){
                DplLink.userPortalPrefs.theme = DplLink.defaultUserPortalPrefs.theme;
            }
             console.log("Portal Prefs: " + JSON.stringify(DplLink.userPortalPrefs));
         } else {
             console.log("No portal prefs defined, use default: ", DplLink.defaultUserPortalPrefs);
        }
        if(done){
            done(err,prefs);
        }
    });
};


DplLink.setUserPortalPrefs = function(done) {
    if(!DplLink.isImpersonating()){
        DplLink.saveUserPrefs('userPortalPrefs',DplLink.userPortalPrefs,(err)=>{
            console.log("Portal Prefs Saved");
            if(done){done(err);}
            
        });
    }
};


DplLink.getUserPrefs = function(key, done) {
    DplLink.apiCall({
        type: 'GET',
        url: DplLink.resthost + DplLink.apiUrls.userPrefs,
        data: { p1: key },
        success: function(response) {
            done(response[0].preferences);
        },
        error:function(jqXHR, textStatus, errorThrown){
            if(done){done(null,textStatus);}
        }
    });
};


DplLink.saveUserPrefs = function(key, prefs,done) {
   if(!DplLink.isImpersonating()){
        DplLink.apiCall({
            type: 'PUT',
            url: DplLink.resthost + DplLink.apiUrls.userPrefs,
            data: { p1: key, p2: JSON.stringify(prefs) },
            success: function(response) {
                console.log('saveUserPrefs:' + JSON.stringify(response));
                if(done){done();}
                
            },
            error:function(jqXHR, textStatus, errorThrown){
                if(done){done(textStatus);}
            }
        });
    }
};

DplLink.requestEmailValidation = function(userid, useportal, done) {
    DplLink.apiCall({
        type: 'GET',
        url: DplLink.resthost + DplLink.apiUrls.requestemailvalidation,
        data: { userid: userid, server: encodeURIComponent(DplLink.validationHost), marketingserver: encodeURIComponent(DplLink.marketingHost), useportal: useportal },
        success: function(response) {
            done(response);
        }
    });
};


DplLink.getJournalType =  function(rmstype, jrnl ){
    var journalCode = {};
    var journalType = "";
    var transType = "";
    var transTypeCode= "";
    var transAct = "";
    var transActCode = "";
    var transActCodeRaw = "--";
    var transToAct = "";
    var transToActCode = "";
    var transToActCodeRaw = "--";
    switch (rmstype) {
        case 1: //Triton
            journalCode = DplLink.journalTypeTriton[jrnl.jcode];
            
            if(journalCode != undefined){
                journalType = journalCode.jtype;
            } else {
                journalType = 'O';
                journalCode = {jtype: "O", jdesc: jrnl.jcode};
            }
            if(journalType == 'T' && DplLink.transactionTypeTriton[jrnl.tcode]){
                transType = DplLink.transactionTypeTriton[jrnl.tcode].tdesc;
            }
            break;
        case 2: //Moniview
            journalCode = DplLink.journalTypeMoniview[jrnl.jcode];

            transActCode = DplLink.transactionAccountMoniview[jrnl.tranaccount];
            if(transActCode != undefined){
                transAct = transActCode;
                transActCodeRaw = jrnl.tranaccount;
            }

            transToActCode = DplLink.transactionAccountMoniview[jrnl.trantoacccode];
            if(transToActCode != undefined){
                transToAct = transToActCode;
                transToActCodeRaw = jrnl.trantoacccode;
            }

            if(journalCode != undefined){
                journalType = journalCode.jtype;
            } else {
                journalType = 'O';
                journalCode = {jtype: "O", jdesc: jrnl.jcode};
            }
            if(journalType == 'T' && DplLink.transactionTypeMoniview[jrnl.tcode]){
                transType = DplLink.transactionTypeMoniview[jrnl.tcode].tdesc;
                transTypeCode = DplLink.transactionTypeMoniview[jrnl.tcode].tcode;
            }
            break;
        case 3: //GenRMS
            journalCode = DplLink.journalTypeGenrms[jrnl.jcode];
            transActCode = DplLink.transactionAccountGenrms[jrnl.tranaccount];
            if(transActCode != undefined){
                transAct = transActCode;
                transActCodeRaw = jrnl.tranaccount;
            }
            if(journalCode != undefined){
                journalType = journalCode.jtype;
            } else {
                //console.log(jrnl.jcode);
                //console.log(jrnl);
                journalType = 'O';
                journalCode = {jtype: "O", jdesc: jrnl.jcode};
            }
            if(journalType == 'T' && DplLink.transactionTypeGenmega[jrnl.tcode]){
                transType = DplLink.transactionTypeGenmega[jrnl.tcode].tdesc;
            }
            break;
        default:
            break;
    }
    return {jt:journalType, jc:journalCode, tt:transType, ttc:transTypeCode, tac:transAct, tacr:transActCodeRaw, ttac:transToAct, ttacr:transToActCodeRaw};
};



window.DplError={};//we could include the DplError class from dplRest if needed
DplError.ERROR_GENERIC=0;
DplError.ERROR_RMS_TRITONSALT_OOBOUND=1;
DplError.ERROR_RMS_ATM_NOT_FOUND=2;
DplError.ERROR_RMS_ACTION_FAILED=3;
DplError.ERROR_RMS_DOWNLOAD_FAILED=4;
DplError.ERROR_ATM_NOT_VALIDATED=5;


DplError.ERROR_USER_NOT_AUTHORIZED=1000;